// extracted by mini-css-extract-plugin
module.exports = {"pintxo-progress-indicator":"ProgressIndicator_pintxo-progress-indicator__CuqQt","progressIndicator":"ProgressIndicator_progressIndicator__JBKeP"};